module.exports = __webpack_public_path__ + "img/3cb-2l-3p-re.d583223a.png";